import React from 'react';

import Application from '@/components/Subscription/Values/Application';
import JustForYou from '@/components/Subscription/Values/JustForYou';
import Listening from '@/components/Subscription/Values/Listening';
import Rewards from '@/components/Subscription/Values/Rewards';
import Track from '@/components/Subscription/Values/Track';

const Values = () => {
  return (
    <div className='md:px-0 px-2.5 md:pb-16 pb-8'>
      <div className='flex justify-center md:mt-16 mt-8 md:mb-16  mb-8'>
        <p className='max-w-2xl text-center md:text-2xl text-base font-medium text-white/60'>
          <span className='text-white text-center'>
            Big ideas. Daily wins. Lifelong impact.
          </span>
          <br />
          <br />
          ZebraLearn brings together the best of self-growth in one beautifully
          simple experience.
        </p>
      </div>
      <div className='grid grid-rows-12 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5 '>
        <div className='col-span-1 row-span-12'>
          <Application />
        </div>
        <div className='col-span-1 row-span-6'>
          <Rewards />
        </div>
        <div className='col-span-1 row-span-5'>
          <JustForYou />
        </div>
        <div className='col-span-1 row-span-7'>
          <Listening />
        </div>
        <div className='col-span-1 row-span-6'>
          <Track />
        </div>
      </div>
    </div>
  );
};

export default Values;
